"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const ZendeskWidgetUtil_1 = tslib_1.__importDefault(require("../../../util/ZendeskWidgetUtil"));
const andes_icons_1 = require("@yonderland/andes-icons");
const andes_react_1 = require("@yonderland/andes-react");
const ProductDetailV2Container_1 = require("../../../containers/product/ProductDetailV2Container");
const StoreFinderButtonAlpha = ({ text, selectedSku, isStickyBar, openCC, sizeForgotten, variant = 'secondary', theme = 'branded', iconProps = {
    source: andes_icons_1.StorefrontIcon,
    size: 'sm',
}, }) => {
    const { ctaRef } = (0, ProductDetailV2Container_1.useProductDetailContext)();
    const isMobile = (0, andes_react_1.useMediaQueryMatchesOnMobile)();
    const hideText = isMobile && isStickyBar;
    const openClickAndCollect = () => {
        openCC();
        ZendeskWidgetUtil_1.default.updateZIndex(1);
    };
    const handleClick = () => (!selectedSku ? sizeForgotten() : openClickAndCollect());
    return ((0, jsx_runtime_1.jsx)(andes_react_1.ButtonAlpha, { innerRef: !isStickyBar ? ctaRef : undefined, iconRight: hideText ? iconProps : undefined, iconLeft: !hideText ? iconProps : undefined, fullWidth: !isStickyBar, size: !isStickyBar ? 'md' : 'sm', onClick: handleClick, variant: variant, theme: theme, text: !hideText && text, testId: "view_stock" }));
};
exports.default = StoreFinderButtonAlpha;
